import React, { FC, useState, useEffect, ReactElement } from "react";
import { useForm } from "react-hook-form";
import { LoginError, LoginRequest } from "../../data/interfaces/loginRequest";
import { GetLoginError, SubmitFormData } from "../../data/loginService";
//import { ExitButton } from "../../Pages/Styles";
import ELogo from '../../assets/images/everlogic.png';
import { ModalType } from "../../data/constants";
import parse from 'html-react-parser'
import {
    LoginForm,
    LoginHeading,
    LoginPaper,
    HiddenID
} from "../Styles";
import LoginFormComponent from "./LoginForm";
import { FormData } from "../../data/interfaces/dataMessage";
import NewMFA from "../MFA/NewMFA";
import MFACheck from "../MFA/MFACheck";
import MFAOption from "../MFA/MFAOption"
import { PostMessage } from "../../data/loginService";
import { UserData, NewUserData, SystemData } from "../../data/interfaces/userInfo"
interface myProps {
    onAlertIdChange: any;
    alertId: number;
    isOpen: boolean;
    setLoading: () => void;
    isLoginPaused: boolean;
    setLoginPause: React.Dispatch<React.SetStateAction<boolean>>;
    formFromURL: string;
    setvalidMFA: React.Dispatch<React.SetStateAction<boolean>>;
    validMFA: boolean;
    setUserInfo: React.Dispatch<React.SetStateAction<NewUserData>>;
    userInfo: NewUserData
    setFormDisplay:React.Dispatch<React.SetStateAction<string>>;
    formDisplay: string;
}


const Login: FC<myProps> = (props) => {
    const { register, handleSubmit, setValue, reset, setError, resetField, formState: { submitCount ,errors } }
        = useForm<FormData>({defaultValues:{RememberMe: false}, criteriaMode: "all" });


    const [loginError, setLoginError] = useState<LoginError>(ModalType[0]);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [loginInfo, setLoginInfo] = useState<LoginRequest>();
    const [systemData, setSystemData] = useState("");
    const [loginAttempts, setLoginAttempts] = useState<number>(0);

    useEffect(() => {
        reset()
    }, [props.formDisplay]);

    useEffect(() => {
        if (Object.keys(errors).length) {
            setLoginAttempts(prevCount => prevCount + 1);
        }
      }, [submitCount, errors]);

    useEffect(() => {
        if (props.formFromURL) {
            props.setFormDisplay(props.formFromURL)
        }

    }, [props.formFromURL]);

    useEffect(() => {
        (window as any).updateAlertId = updateAlertId;
        (window as any).changeForm = props.setFormDisplay;

        (window as any).setPhoneNumber = setPhoneNumber;
        const fetchData = async () => {
            try {
                const errorInfo = await GetLoginError(props.alertId);

                if (errorInfo == null) {
                    setLoginError(ModalType[1])
                }
                else {
                    setLoginError({ Message: parse(errorInfo.message), Type: errorInfo.type, DisplayID: parseInt(errorInfo.displayId) })
                }
            } catch (errorInfo) {
                setLoginError(ModalType[1])
            }
        };

        if (props.alertId >= 100 && props.alertId <= 999) {
            fetchData();
        }


        return () => {
            // Clean up the global reference when the component unmounts
            delete (window as any).setMyCheckboxState;
        };
    }, [props.alertId]);

    (window as any).SendSystemInfoToBrowser = (result: string) => {
        setSystemData((result));
    }

    (window as any).setLoginForm = (dealer: string, userName: string, password: string, rememberMe: string) => {
        const userData: LoginRequest = {
            Username: userName,
            Password: password,
            Dealer: dealer,
            rememberMe: rememberMe == "true" ? true : false
        };
        setLoginInfo(userData);
    }

    useEffect(() => {
        if(props.userInfo.userId == 0){
            PostMessage(true, "SendInfo")
        }
    });

    useEffect(() => {
        function handleEvent(event: MessageEvent) {
            if(event.data.Type=="SystemInfo"){

                setSystemData(event.data.SystemInfo);
            }
            
        }
        window.addEventListener('message', handleEvent);

        return () => {
            window.removeEventListener('message', handleEvent);
        };
    });

    useEffect(() => {
        if(props.formDisplay === "UserLogin" && loginAttempts>=5){
            PostMessage("","CloseForm")
        }
    }, [loginAttempts]);


    function convertAndRemoveNonDigits(phoneNumber: string): string {
        const digitsOnly = phoneNumber.replace(/\D/g, '');

        if (digitsOnly.length !== 10) {
            throw new Error('Invalid phone number. Expected 10 digits.');
        }

        return digitsOnly;
    }
    const handleFormSubmit = handleSubmit(async (data: FormData) => {
        props.setLoginPause(true)
        if (props.formDisplay === "UserLogin" && systemData) {
            data = { ...JSON.parse(systemData), ...data }
        }
        const response = await SubmitFormData(data, props.formDisplay, props.setvalidMFA)
        if (props.formDisplay === "SaveUserInfo") {

            if (response && response?.status === 200) {
                if (data.Phone) {
                    data.Phone = convertAndRemoveNonDigits(data.Phone)
                }
                props.setUserInfo(prevUserInfo => ({
                    ...prevUserInfo,
                    Phone: data.Phone,
                    Email: data.Email,
                    mfaEmail: data.Email,
                    mfaPhone: data.Phone,
                    birthDate: data.DOB
                }));
            }
        }
        if (props.formDisplay === "CheckCode") {
            if (!response || response?.data === 0) {
                setError("Code", { type: "Incorrect", message: "The entered code is incorrect or expired." })
            }
            else {
                PostMessage(props.userInfo, "LastForm")
            }

        }
        if (props.formDisplay === "UserLogin") {
            if(response) {
                updateAlertId(0)
                let alertId = response?.data.alertId;
                if (alertId && alertId !== 0 && alertId !== "0") {
                    updateAlertId(parseInt(alertId));
                    setLoginAttempts(prevCount => prevCount + 1);
                }
                let userData = response.data as NewUserData;
                userData.rememberMe = data.RememberMe;
                props.setUserInfo(userData);
            }
        }
        if (props.formDisplay === "SendCode") {
            if (response) {
                props.setFormDisplay("CheckCode")
            }
        }
        props.setLoginPause(false)
    });

    useEffect(() => {
        props.setLoginPause(false)
        setLoginAttempts(0)
    }, [props.formDisplay]);


    function updateAlertId(newAlertId: number) {
        if (newAlertId !== props.alertId) {
            props.onAlertIdChange(newAlertId);
        }
    }


    const renderSwitch = (param: string): ReactElement => {
        switch (param) {
            case "UserLogin":
                return <LoginFormComponent setValue={setValue} loginError={loginError} errors={errors} loginData={loginInfo} register={register} isOpen={props.isOpen} setLoading={props.setLoading} isLoginPaused={props.isLoginPaused} />
            case "SaveUserInfo":
                return <NewMFA loginPaused={props.isLoginPaused} resetFormError={resetField} setFormError={setError} setUserInfo={props.setUserInfo} register={register} errors={errors} setFormData={setValue} user={props.userInfo} />
            case "SendCode":
                return <MFAOption loginPaused={props.isLoginPaused} user={props.userInfo} setFormData={setValue} />
            case "CheckCode":
                return <MFACheck loginPaused={props.isLoginPaused} changeForm={props.setFormDisplay} validMFA={props.validMFA} user={props.userInfo} setFormData={setValue} phoneNumber={phoneNumber} register={register} errors={errors} />

            default:
                return <div><h3>The requested form is not available.</h3></div>
        }
    }


    return (
        <LoginPaper elevation={10}>
            <LoginForm onSubmit={handleFormSubmit}>
                <div className="exit-container">
                    {/* <ExitButton
                        type="button"
                        onClick={closeTab}>
                        <FontAwesomeIcon icon={faXmark} size="xl" className="exit-button" />
                    </ExitButton> */}
                </div>
                <LoginHeading>
                    <img src={ELogo} alt="EverLogic Logo" className="e-logo" />
                </LoginHeading>
                {
                    // RenderSwitch will change the below component based on the formDisplay state
                    // the formDisplay state will also be sent in the PostMessage function to the DMS / Mobile Window / API
                    renderSwitch(props.formDisplay)
                }
            </LoginForm>
            <HiddenID id="LoginID"></HiddenID>
        </LoginPaper>
    );
};

export default Login;